import { render, staticRenderFns } from "./MoveCard.vue?vue&type=template&id=448f1382&scoped=true&"
import script from "./MoveCard.vue?vue&type=script&lang=js&"
export * from "./MoveCard.vue?vue&type=script&lang=js&"
import style0 from "./MoveCard.vue?vue&type=style&index=0&id=448f1382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f1382",
  null
  
)

export default component.exports